import { ApiClientService, EntityApiService } from '@dfl/react-security';

class PaymentService extends EntityApiService<any> {
  checkPaymentStatus = (orderId: string, config?: any) => {
    return this.handleResponse(ApiClientService.get(this.getPath(`/reference/${orderId}/status`), config));
  };
}

export default new PaymentService('/ms-pay/api/admin/payment');
